<template>
    <div class="min-h-[400px] w-full px-4 py-6">
        <div
            :class="['max-w-[1600px] mx-auto rounded-3xl overflow-hidden bg-gradient-to-b from-white/70 to-white/100 shadow-lg', outerMarginClass]">
            <h1
                class="w-full pt-2 pb-3 mb-2 text-2xl font-bold leading-tight text-center text-[#17408B] tracking-tight">
                Pimpinan Jurusan
            </h1>
            <div class="flex flex-col items-center justify-center gap-6 md:flex-row md:gap-0">
                <div v-for="(item, idx) in normalized" :key="item.id || idx"
                    class="relative flex-1 flex flex-col items-center justify-end min-h-[480px] h-full">
                    <!-- Foto -->
                    <img :src="fotoUrl(item.dosen?.foto, item.dosen?.nama)"
                        :alt="`Foto ${item.dosen?.nama || 'Pejabat'}`"
                        class="w-full h-[400px] object-cover object-center" />
                    <!-- Overlay gradient + text -->
                    <div
                        class="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-black/75 via-black/10 to-transparent rounded-3xl">
                        <div class="p-8 pb-6">
                            <div
                                class="mb-1 text-lg font-bold leading-snug text-center text-white md:text-xl line-clamp-3">
                                {{ item.dosen?.nama || '-' }}
                            </div>
                            <div class="mb-6 text-sm font-medium leading-tight text-center text-white md:text-base">
                                {{ item.jabatan?.namajabatan || '-' }}
                            </div>
                            <button
                                class="w-full py-2 text-white font-medium border border-white rounded-lg bg-transparent hover:bg-white hover:text-[#17408B] transition"
                                @click="openDosen(item)">
                                Lihat Profil
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal profil dosen (sama seperti pada halaman Dosen) -->
        <ProfilDosen v-model:isOpen="isModalOpen" :dosendata="viewDosen" />
    </div>
</template>

<script setup>
import { defineProps, computed, ref } from "vue";
import ProfilDosen from "@/Components/Web/ProfilDosen.vue";

// Props: menerima object { data: [...] } sesuai contoh
const props = defineProps({
    pejabatList: {
        type: [Object, Array],
        required: true,
    },
    outerMargin: { // Tailwind margin utilities e.g. 'mt-4 mb-6'
        type: String,
        default: 'my-4'
    }
});
const isModalOpen = ref(false);
const viewDosen = ref(null);

// Data pejabat sudah membawa objek dosen lengkap (via FormasiResource),
// jadi buka modal ProfilDosen yang sama seperti di halaman Dosen langsung.
const openDosen = (item) => {
    viewDosen.value = item?.dosen || null;
    isModalOpen.value = true;
};

const normalized = computed(() => {
    if (Array.isArray(props.pejabatList)) return props.pejabatList;
    if (props.pejabatList && Array.isArray(props.pejabatList.data)) return props.pejabatList.data;
    return [];
});

const outerMarginClass = computed(() => props.outerMargin);

// Helper for foto url (use your own logic if needed)
function fotoUrl(foto, nama = "User") {
    if (!foto) {
        return `https://ui-avatars.com/api/?name=${encodeURIComponent(nama)}&background=e5e7eb&color=6b7280&size=256`;
    }
    if (/^https?:\/\//.test(foto) || foto.startsWith("/storage")) {
        return foto;
    }
    return "/storage/" + foto;
}
</script>

<style scoped>
.rounded-3xl {
    border-radius: 2rem;
}
</style>